import { Dispatch } from 'react'
//import { toast } from 'react-toastify'
import { updateProcessing, updateNoticeData } from 'state/user/reducer'

export function messageHandle(e: string, dispatch: Dispatch<any> | null) {
  if (e && e.indexOf('}') > -1) {
    const data = JSON.parse(e)
    //debug
    //toast.success(
    //  `<Toast
    //    title={"123"}
    //    linkText="Check Records"
    //    message=""
    //    link="/records"
    //  ></Toast>`
    //)
    if (data.event === 'process') {
      if (data.data && dispatch) {
        dispatch(updateProcessing(data.data))
      }
    }
    if (data.event === 'notice') {
      const noticeData = JSON.parse(data.data)
      if (dispatch) {
        dispatch(updateNoticeData(noticeData))
      }
    }
  }
}
